// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {compose, lifecycle} from 'recompose'

import AdminCompanyList from '../components/AdminCompanyList/AdminCompanyList'
import * as actions from '../actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {Match} from 'react-router'
import type {AdminState} from '../types/index'

export type StateProps = {
  companies: $PropertyType<AdminState, 'companies'>,
  isLoadingCompanies: $PropertyType<AdminState, 'isLoadingCompanies'>,
  error: $PropertyType<AdminState, 'error'>
};

export type OwnProps = {
  match: ?Match
};

export type DispatchProps = {
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  addOrUpdateCompany: $PropertyType<typeof actions, 'addOrUpdateCompany'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = state => {
  return {
    companies: state.admin.companies,
    isLoadingCompanies: state.admin.isLoadingCompanies,
    error: state.admin.error
  }
}

const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {}
  })
)(AdminCompanyList)
